import { render, staticRenderFns } from "./CgformAutoListTable.vue?vue&type=template&id=09ca6b62&scoped=true&"
import script from "./CgformAutoListTable.vue?vue&type=script&lang=js&"
export * from "./CgformAutoListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca6b62",
  null
  
)

export default component.exports